import React from "react";
import { Row, Col, Statistic, Card, Progress, Divider } from "antd";
import {
  ShoppingOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  RedoOutlined,
} from "@ant-design/icons";

import PaymentBreakdown from "./PaymentBreakdown";

// Top KPI row: order counts across all drivers for the selected day, plus the
// aggregated Efectivo/Transferencia/Tarjeta collection totals.
const RouteMonitoringSummary = ({ counts, recaudacion, total, loadingSummary }) => {
  const delivered = counts.delivered + counts.partiallyDelivered;
  const terminalCount = delivered + counts.notDelivered + counts.rescheduled;
  const completionPercent = counts.total > 0 ? Math.round((terminalCount / counts.total) * 100) : 0;

  return (
    <Card className="mb-4">
      <Row gutter={[24, 16]} align="middle">
        <Col xs={12} sm={8} lg={4}>
          <Statistic title="Pedidos" value={counts.total} prefix={<ShoppingOutlined />} />
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Statistic
            title="Entregados"
            value={delivered}
            suffix={
              counts.partiallyDelivered > 0 ? `(${counts.partiallyDelivered} parcial)` : undefined
            }
            valueStyle={{ color: "#3f8600" }}
            prefix={<CheckCircleOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Statistic
            title="Pendientes"
            value={counts.pending + counts.enRuta}
            valueStyle={{ color: "#d48806" }}
            prefix={<ClockCircleOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Statistic
            title="No entregados"
            value={counts.notDelivered}
            valueStyle={{ color: "#8c8c8c" }}
            prefix={<CloseCircleOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} lg={4}>
          <Statistic
            title="Reagendados"
            value={counts.rescheduled}
            valueStyle={{ color: "#1677ff" }}
            prefix={<RedoOutlined />}
          />
        </Col>
        <Col xs={24} sm={16} lg={4}>
          <Progress type="circle" size={72} percent={completionPercent} />
        </Col>
      </Row>
      <Divider style={{ margin: "16px 0" }} />
      <PaymentBreakdown recaudacion={recaudacion} total={total} loading={loadingSummary} />
    </Card>
  );
};

export default RouteMonitoringSummary;
